import React, { useEffect, useState } from "react"
import { getAllSystemNotifications } from "../util/db"
import { XMarkIcon } from "@heroicons/react/24/solid"

export default function SystemNotificationBanner() {
  const [dismissed, setDismissed] = useState(false)
  const [visible, setVisible] = useState(false)
  const [title, setTitle] = useState("")
  const [subtitle, setSubtitle] = useState("")
  const [notificationID, setNotificationID] = useState("")
  const [link, setLink] = useState("")
  const [linkText, setLinkText] = useState("")

  useEffect(() => {
    const fetchNotification = async () => {
      const data = await getAllSystemNotifications()
      let notification
      if (data.length > 0) {
        notification = data[0]
      } else {
        return // TODO: error out here
      }
      if (notification?.id) {
        setNotificationID(notification?.id)
      }
      if (notification?.title) {
        setTitle(notification?.title)
      }
      if (notification?.subtitle) {
        setSubtitle(notification?.subtitle)
      }
      if (notification?.visibility) {
        setVisible(notification?.visibility)
      }
      if (notification?.link) {
        setLink(notification.link)
      }
      if (notification?.linkText) {
        setLinkText(notification.linkText)
      }
    }

    fetchNotification()
  }, [])

  return (
    <>
      {(visible && !dismissed) && (
        <div className="w-full bg-green-700 text-white px-4 py-4 sm:px-6 pr-10 relative">
          <div className="max-w-4xl mx-auto flex flex-col items-center text-center md:flex-row md:justify-center md:gap-x-6">
            <div>
              <h3 className="text-lg font-semibold text-white">{title}</h3>
              <p className="text-sm mt-1 text-green-100">{subtitle}</p>
            </div>
            {link && (
              <a
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-3 md:mt-0 inline-block rounded-md bg-white text-green-700 px-5 py-2 text-sm font-semibold shadow-sm hover:bg-green-50 transition-colors whitespace-nowrap"
              >
                {linkText || "Learn More"}
              </a>
            )}
          </div>
          <button
            onClick={() => setDismissed(true)}
            className="absolute right-2 top-2 sm:right-4 sm:top-1/2 sm:transform sm:-translate-y-1/2 text-green-200 hover:text-white p-1"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>
      )}
    </>
  );
}
